<template>
  <div>
    <div class="details-content">
      <div class="details-content-t">
        <div class="namebox">
          <div class="name">
            {{ language == "cn" ? dateList.name : dateList.enName }}
          </div>
          <!-- <div class="status">待开始</div> -->
        </div>
        <div class="nums">{{$t('meetNums')}}：{{dateList.txNumber}}</div>
      </div>
      <div class="details-content-m">
        <div class="start-time">
          <div class="day">{{startTime.slice(0,10)}}</div>
          <div class="time">{{startTime.slice(10,startTime.length)}}</div>
        </div>
        <div class="line">-</div>
        <div class="end-time">
          <div class="day">{{endTime.slice(0,10)}}</div>
          <div class="time">{{endTime.slice(10,endTime.length)}}</div>
        </div>
      </div>
      <div class="details-content-b">
        <div class="item">
          <div class="label">{{$t('meetChair')}}</div>
          <div class="content">
            <span>{{dateList.moderatorName}}</span>
            <span class="arrow opacity0"></span>
          </div>
        </div>
        <div class="item">
          <div class="label">{{$t('meetJoinPeople')}}</div>
          <div class="content" @click="toUrl">
            <span>{{$t('invited')}}{{dateList.joinPersonNumber}}{{$t("people")}}</span>
            <span class="arrow"></span>
          </div>
        </div>
      </div>
      <!-- <div class="apply-btn" :style="{ background: bgStyle }">申请参会</div> -->
      <openappview openKey="LiveDetail" :tips="tips"></openappview>
    </div>
  </div>
</template>

<script>
import openappview from '../../components/openAppView'
 
export default {
  name: "",
  data() {
    return {
      id: "",
      txNumber: "",
      language: this.$route.query.languageType,
      dateList: {},
      startTime:"",
      endTime:"",
      bgStyle:this.$route.query.bgcolor,
      tips:"下载家具礼品展App加入会议"
    };
  },
  components:{
    openappview
  },
  mounted() {
    this.meetingGet();
  },
  methods: {
    toUrl(){
      this.$router.push({
        name:"attendee",
        query:{
          id:this.$route.query.id,
          exhibitionId:this.dateList.exhibitionId
        }
      })
    },
    meetingGet() {
      var params = {
        id: Number(this.$route.query.id),
        txNumber: this.$route.query.txNumber,
      };
      this.$http.meetingGet(params).then((res) => {
        this.dateList = res.data;
        this.startTime = this.moment(res.data.startTime).format("YYYY-MM-DD HH:mm")
        this.endTime = this.moment(res.data.endTime).format("YYYY-MM-DD HH:mm")  
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.details-content {
  &-t {
    padding: 12px 12px 0;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #f5f6fa;
    .namebox {
      display: flex;
      justify-content: space-between;
      align-items: top;
      .name {
        width: 263px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
        margin-left: 3px;
      }
      .status {
        width: 49px;
        height: 18px;
        line-height: 18px;
        background: #4690ff;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #ffffff;
        line-height: 15px;
        text-align: center;
      }
    }

    .nums {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #6e7580;
      line-height: 19px;
      margin-top: 8px;
      padding-bottom: 16px;
    }
  }
  &-m {
    background-color: #fff;
    padding: 20px 58px 20px 46px;
    display: flex;
    justify-content: space-between;
    .line {
      font-size: 36px;
      padding-top: 25px;
    }
    .start-time,
    .end-time {
      display: flex;
      flex-direction: column;
      .day {
        width: 76px;
        height: 19px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6e7580;
        line-height: 19px;
      }
      .time {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 50px;
        margin-top: 4px;
      }
    }
  }
  &-b {
    margin-top: 4px;
    background-color: #fff;
    .item {
      display: flex;
      justify-content: space-between;
      padding: 12px 15px;
      border-bottom: 1px solid #f5f6fa;
      .label {
        height: 21px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999999;
        line-height: 21px;
      }
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .arrow {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-right: 1px solid #c9ced6;
          border-top: 1px solid #c9ced6;
          transform: rotate(45deg);
          margin-left: 9px;
        }
        .opacity0{
          opacity: 0;
        }
      }
    }
    .item:last-child {
      border: none;
    }
  }
  .apply-btn {
    width: 315px;
    height: 44px;
    line-height: 44px;
    background: #b4253c;
    border-radius: 5px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
    letter-spacing: 3px;
    text-align: center;
    margin: 0 auto;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 31px;
  }
}
</style>
